import { render } from "./content-card-slider.vue?vue&type=template&id=04718291"
import script from "./content-card-slider.vue?vue&type=script&lang=js"
export * from "./content-card-slider.vue?vue&type=script&lang=js"

import "./content-card-slider.vue?vue&type=style&index=0&id=04718291&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__